export default "__VITE_ASSET__Clz8tp80__"